module.exports = __webpack_public_path__ + "static/media/BackgroundVideo.d6ffc21d.webm";